import "./scroll.css";
import {
    motion,
    useScroll,
    useMotionValue,
    useSpring,
    useTransform,
    useVelocity,
    useAnimationFrame,
} from "framer-motion";
import { useRef } from "react";
import { wrap } from "@motionone/utils";

function ParallaxImage({ children, baseVelocity = 100 }) {
    // intialize motion value
    const baseX = useMotionValue(0);
    // extract scrollY value from useScroll
    const { scrollY } = useScroll();
    //Transform motion value to velocity for my animation "scroll speed up & down"
    const scrollVelocity = useVelocity(scrollY);
    // For making my animation smooth after stop scrolling it Bounce back to it's original state
    const smoothVelocity = useSpring(scrollVelocity, {
        damping: 50,
        stiffness: 400,
    });

    // this is for Control Direction of scrolling
    const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
        clamp: false,
    });
    // the x value represents the horizontal translation (position) of the <motion.div> component.
    //providing a smooth and controlled animation range.
    const x = useTransform(baseX, (v) => `${wrap(-14.5, 11.5, v)}%`);
    const directionFactor = useRef(1);
    useAnimationFrame((t, delta) => {
        let moveBy = directionFactor.current * baseVelocity * (delta / 10000);
        if (velocityFactor.get() < 0) {
            directionFactor.current = -1;
        } else if (velocityFactor.get() > 0) {
            directionFactor.current = 1;
        }
        moveBy += directionFactor.current * moveBy * velocityFactor.get();
        baseX.set(baseX.get() + moveBy);
        // console.log(baseX);
    });

    return (
        <div className="parallax">
            <motion.div className="scroller w-fit flex justify-center" style={{ x }}>
                <span>{children}</span>
                <span>{children}</span>
                <span>{children}</span>
                <span>{children}</span>
            </motion.div>
        </div>
    );
}

export default ParallaxImage;
